export default "__VITE_ASSET__ZuOEybBl__"